"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    width: ", "px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 0.7em;\n    font-weight: 600;\n    background-color: rgba(0, 0, 0, 0.1);\n    padding: ", "px ", "px;\n    box-sizing: border-box;\n    border-radius: ", "px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Code = exports.Name = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var react_lazy_load_image_component_1 = require("react-lazy-load-image-component");

require("react-lazy-load-image-component/src/effects/blur.css");

exports.Name = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme && styled_components_1.css(_templateObject3(), theme.palette.text["default"]));
});
exports.Code = styled_components_1["default"].div(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme;
  return styled_components_1.css(_templateObject5(), theme.palette.text["default"], theme.palette.background.secondary, theme.spacing.unit * 0.5, theme.spacing.unit, theme.border.radius["default"]);
});
exports.Image = styled_components_1["default"](react_lazy_load_image_component_1.LazyLoadImage)(_templateObject6(), function (_ref3) {
  var theme = _ref3.theme;
  return styled_components_1.css(_templateObject7(), theme.palette.text["default"], theme.spacing.unit * 4);
});